import { useCallback, useEffect, useState } from 'react';

// material-ui
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// project import
import IconButton from 'components/@extended/IconButton';
import axiosClient from 'utils/axios';
import { BASE_URL } from 'utils/baseUrlProvider';
import HeaderTooltip from './HeaderTooltip';

// assets
import WifiOutlined from '@ant-design/icons/WifiOutlined';
import DisconnectOutlined from '@ant-design/icons/DisconnectOutlined';

// ==============================|| HEADER CONTENT - INTERNET STATUS ||============================== //

export default function InternetStatus() {
  const [isOnline, setIsOnline] = useState(true);
  const [checking, setChecking] = useState(false);

  const checkInternetStatus = useCallback(async () => {
    setChecking(true);
    try {
      const response = await axiosClient.get(`${BASE_URL}/miscellaneous/get_internet_status/`);
      setIsOnline(response.data.internet === true);
    } catch (error) {
      setIsOnline(false);
      console.error('Error checking internet status:', error);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    checkInternetStatus();

    const intervalId = setInterval(checkInternetStatus, 5 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [checkInternetStatus]);

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75, display: 'flex', alignItems: 'center' }}>
      <HeaderTooltip title={checking ? 'Checking Internet Status...' : isOnline ? 'Server is Online' : 'Server is Offline'}>
        <span>
          <IconButton
            color={isOnline ? 'success' : 'error'}
            variant="text"
            sx={{
              color: isOnline ? 'success.main' : 'error.main'
            }}
            aria-label="internet status"
            onClick={checkInternetStatus}
            disabled={checking}
          >
            {isOnline ? <WifiOutlined /> : <DisconnectOutlined />}
          </IconButton>
        </span>
      </HeaderTooltip>
      {!isOnline && <Typography sx={{ height: 'fit-content', color: 'error.main', width: 'fit-content' }}>Internet Unavailable (Hybrid Mode)</Typography>}
    </Box>
  );
} 
